var _rect, _text, _rect2, _circle, _path, _text2, _text3, _text4, _rect3, _circle2, _circle3, _circle4, _path2, _text5, _text6, _text7, _rect4, _circle5, _circle6, _path3, _text8, _text9, _text0, _path4, _rect5, _circle7, _path5, _path6, _text1, _text10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportFinalDemonstrationOneSiteScopeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 760,
    viewBox: "0 0 620 760",
    role: "img",
    "aria-label": "Work Passport demonstration scope mobile card",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 760,
    rx: 38,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 62,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "PRACTICAL DEMONSTRATION SCOPE")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 110,
    width: 536,
    height: 138,
    rx: 23,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 179,
    r: 33,
    fill: "#087CFF",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8 189.4v-21.6h22.400000000000002v21.6M92.4 173.4h2.4000000000000004m4 0h2.4000000000000004m4 0h2.4000000000000004M84.4 189.4h27.200000000000003",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 156,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 187,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "One site")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 216,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "A real deployment environment")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 276,
    width: 536,
    height: 138,
    rx: 23,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 345,
    r: 33,
    fill: "#F54291",
    fillOpacity: 0.13
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4,
    cy: 339.4,
    r: 4,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.4,
    cy: 340.2,
    r: 3.2,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2 355.4c0-6.4 14.4-6.4 14.4 0M100.4 354.6c0-4.800000000000001 11.200000000000001-4.800000000000001 11.200000000000001 0",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 322,
    fill: "#F54291",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 353,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "One workforce segment")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 382,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "A meaningful employee group")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 442,
    width: 536,
    height: 138,
    rx: 23,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 511,
    r: 33,
    fill: "#30D6A1",
    fillOpacity: 0.13
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 503.8,
    r: 4.800000000000001,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6 522.2c0-9.600000000000001 20.8-9.600000000000001 20.8 0",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 488,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 519,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "One role family")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 548,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "The requirements attached to the work")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310 608v28",
    stroke: "#29405D",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 636,
    width: 536,
    height: 80,
    rx: 22,
    fill: "#10243E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 676,
    r: 24,
    fill: "#30D6A1",
    fillOpacity: 0.14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 666.08l8.68 3.1v6.2c0 5.58-3.7199999999999998 9.3-8.68 11.78-8.68-2.48-8.68-6.2-8.68-11.78v-6.2z",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.66 676l3.1 3.1 6.2-6.82",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 667,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "DEMONSTRATION RESULT")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 695,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 17,
    fontWeight: 850
  }, "A live readiness model you can interrogate")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportFinalDemonstrationOneSiteScopeMobile);
export default __webpack_public_path__ + "static/media/work-passport-final-demonstration-one-site-scope-mobile.f167fd87a4c600cf208e5607427102b1.svg";
export { ForwardRef as ReactComponent };